import { motion } from "framer-motion";
import { MessageCircle, Phone, Sparkles, CheckCircle } from "lucide-react";

const interactionMethods = [
  {
    icon: <MessageCircle className="w-6 h-6 text-blue-600" />,
    title: "Text-to-Speech",
    description: "Type your responses and hear Gia speak back to you",
    features: [
      "Type at your convenience",
      "Natural voice responses from Gia",
      "Perfect for quiet environments"
    ]
  },
  {
    icon: <Phone className="w-6 h-6 text-blue-600" />,
    title: "Speech-to-Speech",
    description: "Have natural voice conversations with Gia",
    features: [
      "Completely hands-free",
      "Natural two-way dialogue",
      "Like talking to a real person"
    ]
  },
  {
    icon: <Sparkles className="w-6 h-6 text-blue-600" />,
    title: "Digital Care Companion",
    description: "Full digital experience with visual tracking and insights",
    features: [
      "Visual progress tracking",
      "Rich interactive features",
      "Complete care management"
    ]
  }
];

export const InteractionSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-8">Connect Your Way</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose how you'd like to interact with Gia during recovery
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {interactionMethods.map((method, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-purple-100 rounded-xl flex items-center justify-center mb-6">
                {method.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4">{method.title}</h3>
              <p className="text-gray-600 mb-6">{method.description}</p>
              <ul className="space-y-3">
                {method.features.map((feature, i) => (
                  <li key={i} className="flex items-center text-gray-600">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};